import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import L from 'leaflet'

import { getTrackHistoryHours, getApiRoot } from '../../store/configSlice'
import { getShownTrackTransportsId, trackShown } from '../../store/mapSlice'

export function TrackBody({ map, shownTrackTransportsId, trackHistoryHours, trackShown, apiRoot }) {
    useEffect(() => {
        if (map && shownTrackTransportsId) {
            const track = L.tileLayer(
                `${apiRoot}/getTrackTile.php?`
                + 'lat={y}&'
                + 'lon={x}&'
                + `zoom={z}&id=${shownTrackTransportsId}&deep=${trackHistoryHours}&_=${Date.now()}&__=${Date.now()}`,
            )

            track.on('load', () => { trackShown(shownTrackTransportsId) })

            track.addTo(map)

            return () => {
                track.removeFrom(map)
            }
        }

        return undefined
    }, [map, apiRoot, shownTrackTransportsId, trackShown, trackHistoryHours])

    return null
}

TrackBody.propTypes = {
    map: PropTypes.any.isRequired,
    shownTrackTransportsId: PropTypes.number,
    trackShown: PropTypes.func.isRequired,
    apiRoot: PropTypes.string.isRequired,
}

const Track = connect(
    state => ({
        shownTrackTransportsId: getShownTrackTransportsId(state),
        trackHistoryHours: getTrackHistoryHours(state),
        apiRoot: getApiRoot(state),
    }), {
        trackShown,
    },
)(TrackBody)

Track.propTypes = {
    map: PropTypes.any.isRequired,
}

export { Track }
